import QuizIcon from '@material-ui/icons/FormatListNumbered';
import DailyGamesList from './components/DailyGamesList';
import { APP_TYPES, roles } from '../../../config/constants';

const options = {
  appTypes: [APP_TYPES.ALL],
  allowedRoles: [roles.ADMIN, roles.JTI_TEAM],
  label: 'Daily Game',
  subMenuName: 'reports',
};

export default {
  list: DailyGamesList,
  icon: QuizIcon,
  name: 'admin/reports/daily-games',
  options,
};
